import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-danxuanxiala" }, null, -1)

import { ref, getCurrentInstance, ComponentInternalInstance, onUnmounted, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'moreButton',
  props: {
  max: {
    type: Number,
    default: 3
  }
},
  setup(__props) {

const { t } = useI18n()
const props = __props
// 按钮最大值12 ,显隐判断只有8个
const moreButtonRef = ref()
const { slots } = getCurrentInstance() as ComponentInternalInstance
const hasMore = ref(false)
const soltNum = ref(0)
const observer = ref<any>(null)
const init = () => {
  const slotlength: number = slots?.default?.().length || 0
  if (slotlength < props.max + 1) {
    return
  }
  const btnContent: any = moreButtonRef.value?.getElementsByClassName('cos-components-moreButton')[0]
  if (btnContent) {
    let length = 0
    for (let i = 0; i < btnContent.children.length; i++) {
      if (btnContent.children[i].style.display !== 'none') {
        length++
        if (length === props.max - 1) {
          soltNum.value = i + 1
        }
      }
    }
    if (length > props.max) {
      hasMore.value = true
    } else {
      hasMore.value = false
      soltNum.value = 0
    }
  }
  // 循环取高宽
}
onMounted(() => {
  init()
  setTimeout(() => {
    const btnContent: any = moreButtonRef.value?.getElementsByClassName('cos-components-moreButton')[0]
    if (btnContent) {
      observer.value = new MutationObserver(init)
      observer.value.observe(btnContent, {
        childList: true,
        attributes: true,
        subtree: true
      })
    }
  })
})
onUnmounted(() => {
  observer.value?.disconnect()
})

return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DcPenetrateContent = _resolveComponent("DcPenetrateContent")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([hasMore.value ? 'more-button-has' : 'more-button', 'flex']),
    ref_key: "moreButtonRef",
    ref: moreButtonRef,
    style: {"align-items":"center"}
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['cos-components-moreButton', `cos-components-moreButton-${soltNum.value}`])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (hasMore.value)
      ? (_openBlock(), _createBlock(_component_a_dropdown, {
          key: 0,
          class: "ant-dropdown-link",
          overlayClassName: "",
          trigger: ['click']
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_DcPenetrateContent, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu, {
                  class: _normalizeClass(['more-button-overlay', `more-button-overlay-${soltNum.value}`]),
                  style: {"background":"rgba(19, 32, 67, 0.9)","padding":"10px 0"}
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "ant-dropdown-link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('btn.more')) + " ", 1),
              _hoisted_1
            ])
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})